import { useEffect, useCallback } from 'react'

type ImagePasteCallback = (file: File) => void

export const usePasteImage = (onImagePaste: ImagePasteCallback) => {
  const handlePaste = useCallback(
    (event: ClipboardEvent) => {
      const items = event.clipboardData?.items
      if (!items) return

      for (let i = 0; i < items.length; i++) {
        const item = items[i]

        if (item.type.indexOf('image') === 0) {
          const file = item.getAsFile()
          if (file) {
            onImagePaste(file)
          }
        }
      }
    },
    [onImagePaste]
  )

  useEffect(() => {
    window.addEventListener('paste', handlePaste)

    return () => {
      window.removeEventListener('paste', handlePaste)
    }
  }, [handlePaste])
}
